// Minimal frontend model for horarios API interactions.
// Exports a payload builder and a save function. Backend contract can change later.
import { postHorarios } from '../services/horariosService';

export function buildSchedulesPayload(schedulesObj) {
  return Object.entries(schedulesObj).flatMap(([day, arr]) => {
    if (!arr || !arr.length) return [];
    return arr.map((s) => ({ day, from: formatTime(s.from), to: formatTime(s.to) }));
  });
}

function formatTime(totalMinutes) {
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}



export async function saveSchedules(schedulesObj) {
  const payload = buildSchedulesPayload(schedulesObj);
  // delegate HTTP to service layer. The service wraps the payload in { schedules: [...] }.
  try {
    const res = await postHorarios(payload);

    // If the service returns a fetch Response
    if (res && typeof res.ok === 'boolean') {
      if (!res.ok) {
          const text = await res.text().catch(() => null);
          console.error('[saveSchedules] server responded with error', res.status, text);
          // fallback: persist locally so the UI doesn't show a blocking error
          try {
            window.localStorage.setItem('horariosDraft', JSON.stringify({ payload, raw: schedulesObj }));
          } catch (e) {
            console.warn('[saveSchedules] failed to write draft to localStorage', e);
          }
          // return payload as the saved value for UI to continue
          return { saved: false, draft: payload };
        }

      // success: attempt to parse JSON, but tolerate empty responses
      return res.json().catch(() => ({ saved: true }));
    }

    // If the service already returned parsed JSON or some other truthy result
    return res;
  } catch (err) {
    // network or unexpected error: log and persist a local draft so the UI isn't blocked
    console.error('[saveSchedules] network/error while posting schedules', err);
    try {
      window.localStorage.setItem('horariosDraft', JSON.stringify({ payload, raw: schedulesObj }));
    } catch (e) {
      console.warn('[saveSchedules] failed to write draft to localStorage', e);
    }
    return { saved: false, draft: payload, error: String(err) };
  }
}

// Load a draft schedules object (raw) if present. Returns schedulesObj or null.
export function loadDraftSchedules() {
  try {
    const raw = window.localStorage.getItem('horariosDraft');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed) return null;
    // prefer raw if present (we saved {payload, raw})
    if (parsed.raw) return parsed.raw;
    // otherwise try to convert payload (array) back into schedulesObj
    if (Array.isArray(parsed)) {
      const out = {};
      parsed.forEach((it) => {
        if (!it || !it.day) return;
        const [h1, m1] = String(it.from).split(':').map((x) => parseInt(x, 10));
        const [h2, m2] = String(it.to).split(':').map((x) => parseInt(x, 10));
        const from = (Number.isNaN(h1) ? 0 : h1) * 60 + (Number.isNaN(m1) ? 0 : m1);
        const to = (Number.isNaN(h2) ? 0 : h2) * 60 + (Number.isNaN(m2) ? 0 : m2);
        out[it.day] = out[it.day] || [];
        out[it.day].push({ from, to });
      });
      return out;
    }
  } catch (e) {
    console.warn('[loadDraftSchedules] failed to parse draft', e);
  }
  return null;
}
